import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";

const faqs = [
  { q: "How do I get an expedited passport in Juneau, Alaska?", a: "Juneau residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents via air and we handle agency submission remotely. Juneau has no road connection to the lower 48, making FPC the only practical expedited option." },
  { q: "Where is the nearest passport agency to Juneau?", a: "The Seattle Regional Passport Agency (915 2nd Ave, Seattle, WA 98174) is the nearest agency — accessible only by flight from Juneau. Fast Passport Center eliminates that trip entirely." },
];

export default function JuneauPage() {
  return (
    <div className="min-h-screen bg-white">
      <CitySEOHead
        city="Juneau"
        state="Alaska"
        stateAbbr="AK"
        route="/cities/juneau"
        title="Expedited & Emergency Passport Services Juneau AK | Fast Passport Center"
        description="Fast Passport Center provides emergency, expedited, and same-day passport services in Juneau, Alaska. Serving City & Borough of Juneau, Mendenhall Valley, Douglas Island, and all Southeast Alaska. As fast as 24 hours — no Seattle flight needed."
        geoPlacename="Juneau, Alaska"
        geoPosition="58.3005;-134.4197"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Alaska"
        statePageRoute="/states/alaska"
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <LocalAreaSection />
      <ServicesSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <FinalCTA />
    </div>
  );
}